import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { TaskService } from '../services/task.services';
import * as jwt_decode from 'jwt-decode';

@Component({
  selector: 'app-task-detail',
  templateUrl: './task-detail.component.html',
  styleUrls: ['./task-detail.component.scss']
})
export class TaskDetailComponent implements OnInit {

  colors = [
    {
     colname:'#F5D428'     
   },
   {
     colname:'#6FC040'
   },
   {
     colname:'#52A7F9'
    },
    {
      colname:'#EF8F1E'
    },
    {
     colname:'#EC5C58'
    },
    {
      colname:'#B36AE2'
    },
 ]
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any=[];
  myOfficeID: any;

  close:boolean = false;
  SubTask:boolean = false;
  PI:boolean = true;
  showSub:boolean = false;
  showTaskOption: any
  selectedTaskOpt: any
  showAssignedTask = false;
  showReminderTask = false;
  showScheduleTask = false;
  showAttachTask = false;
  dialogRef: MatDialogRef<any, any>;
  @Output() closeTaskDetail = new EventEmitter<boolean>()
  @Output() showPI = new EventEmitter<boolean>()

  //@Input() selectedTaskOption : any;
  @Input() taskId : number;
  myTaskForm: FormGroup; 
  taskComplete:boolean = false;
  taskDetailList:any=[]=[];

  showColorPannel = false;
  selectedColor:string = '#db241c';

  constructor(private dialog: MatDialog,
    private loaderService: LoaderService, private cdr: ChangeDetectorRef,
    private _dataSharingService: DataSharingService, private router: Router,    
    private reusableClass: ReusableClasses, private encryptionAlgo: EncryptionService,
    private statusConst: StatusConstant,      
    private taskService: TaskService,
    private formBuilder: FormBuilder, private toastr: ToastrService){
      const encryptedtoken = sessionStorage.getItem('userToken');
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    }


  ngOnInit(): void { 
  }

  ngOnChanges(changes: SimpleChanges) {
    this.taskId;
   // this.selectedTaskOpt = changes.selectedTaskOption.currentValue;
   if(this.taskId>0){
    let group = {};
    this.myTaskForm = new FormGroup(group);
    this.createFormTask();
    this.getTaskDetailByID();
   }    
  }  


   getTaskDetailByID() {
    this.loaderService.show();
    var ReqModel={
        taskID:this.taskId,
       userID: this.currentUser.UID,
       officeID: this.myOfficeID,
       organizationID: Number(this.organizationId),
       officeIDList: this.OfficeIDList
    }      
    this.taskService.getTaskDetailByID(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;        
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
          this.taskDetailList = response.data;
          this.myTaskForm.controls['title'].setValue(this.taskDetailList.title);
          this.myTaskForm.controls['description'].setValue(this.taskDetailList.description);
          this.myTaskForm.controls['dueDate'].setValue(this.taskDetailList.dueDate);
          this.myTaskForm.controls['isInternal'].setValue(this.taskDetailList.dueDate);
          this.selectedColor =this.taskDetailList.colourCode;
          this.loaderService.hide();
        }
        else {
          this.taskDetailList=[];
          this.loaderService.hide();
        }
      }
      else {
        this.taskDetailList=[];
        this.loaderService.hide();
      }
    });
  }

  createFormTask(): void {
    this.myTaskForm = this.formBuilder.group({
     title: ['', [Validators.required]],
     description: ['', [Validators.required]],
     dueDate: ['', [Validators.required]], 
     isInternal:false,
    },);
   } 

   // For Add Task //
   toggleColorSelection(){
    this.showColorPannel = !this.showColorPannel;
  }

  SelectColor(color) {
    this.selectedColor = color;
    this.showColorPannel=false;
  } 




   showIntelligence(message){
    this.showPI.emit(message)
  }

  closedetail(message:boolean){
    this.closeTaskDetail.emit(message)
  }

  showSubtask(){
    this.showSub = !this.showSub;
  }
 
  markComplete(){
    this.taskComplete = !this.taskComplete
  }  

  addTaskOption(val: string){
    if(val === 'Assigned'){
      this.showAssignedTask = true;
    }
    if(val === 'Reminder'){
      this.showReminderTask = true;
    }
    if(val === 'Schedule'){
      this.showScheduleTask = true;
    }
    if(val === 'Attach'){
      this.showAttachTask = true;
    }
  }

  closeTask(val:boolean){
      this.showAssignedTask = val
  }

  closeReminder(val:boolean){
    this.showReminderTask = val
  }

  closeSchedule(val:boolean){
    this.showScheduleTask = val
  }

  closeAttach(val:boolean){
    this.showAttachTask = val
  }

  
  addFolder(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
  }
  

}
